import { Page } from 'layouts/Page';
import { CommunicationHistory } from 'components/EMManagement/EMManagementId/CommunicationHistory';

export const CommunicationHistoryPage = () => {
	return (
		<Page title="Communication History – EAS Control Center">
			<CommunicationHistory />
		</Page>
	);
};
